document.addEventListener("DOMContentLoaded", function () {
    let filters = new Set();
    // let results_count;
    let filters_concerns = document.getElementById('sleep-concerns').dataset.currentFilters;
    let filters_position = document.getElementsByClassName('sleep-position')[0].dataset.selectedFilter;
    let filters_size = document.getElementsByClassName('mattress-size')[0].dataset.selectedFilter
    let filters_type = document.getElementById('mattress_type').dataset.currentFilters;

    function getUpdatedFilterValues() {
        document.getElementById('no-results').classList.add('hidden');
        filters_concerns = document.getElementById('sleep-concerns').dataset.currentFilters;
        filters_position = document.getElementsByClassName('sleep-position')[0].dataset.selectedFilter;
        filters_size = document.getElementsByClassName('mattress-size')[0].dataset.selectedFilter;
        filters_type = document.getElementById('mattress_type').dataset.currentFilters;

        if (filters_concerns) {
            const current_filters = filters_concerns.split(',');
            current_filters.forEach(element => {
                if(element != '') {
                    filters.add(element);
                }
            });
        }
        if (filters_position) {
            filters.add(filters_position);
        }
        if (filters_size) {
            filters.add(filters_size);
        }
        if (filters_type) {
            const current_filters = filters_type.split(',');
            current_filters.forEach(element => {
                if(element != '') {
                    filters.add(element);
                }
            });
        }
    }
    document.querySelectorAll('.sort-button__item').forEach(button => {
        button.addEventListener('click', function(){
            let current_element = document.getElementById('mattress_type');
            let existing_element_filters = document.getElementById('mattress_type').dataset.currentFilters;
            let filterText = [];
            let filterValue = button.dataset.sortButton;
            let isPressed = button.getAttribute('aria-pressed') === 'true';
            button.setAttribute('aria-pressed', String(!isPressed));
            getUpdatedFilterValues();
            if(button.classList.contains('active')){
                let re = new RegExp("(" + filterValue + ",|" + filterValue + ")", "g");
                current_element.dataset.currentFilters = existing_element_filters.replace(re, "");
                filters.delete(filterValue);
                button.classList.remove('active');
            }else{
                if(existing_element_filters) {
                    current_element.dataset.currentFilters = existing_element_filters + "," + filterValue;
                } else {
                    current_element.dataset.currentFilters = filterValue;
                }
                filters.add(filterValue);
                button.classList.add('active');
            }
            document.querySelectorAll('.sort-button__item.active').forEach(item => {
                let text = item.dataset.sortButton;
                filterText.push(text);
            })
            filterText.forEach(element => {
                filters.add(element);
            });
            let results_count = 0;
            document.querySelectorAll('.product-wrapper__item').forEach(item => {
                if((typeof item.dataset.tags !== "undefined" && item.dataset.tags !== null) && filters.size != 0){
                    item.classList.remove('hidden');
                    const filtersArray = [...filters];
                    const hasTag = filtersArray.every(el => item.dataset.tags.includes(el));
                    if (!hasTag){
                        results_count++;
                        item.classList.add('hidden');
                    }
                } else {
                    item.classList.remove('hidden');
                }
                if(results_count == 6){
                    showAll();
                }
            });
        })
    })
    
    document.querySelectorAll('.select-popout__list__scroll.size-toggle .select-popout__item').forEach(element => {
        element.addEventListener('click', function(){
            element.closest('.select-popout__list__scroll').querySelectorAll('.select-popout__item').forEach(option => {
                option.classList.remove('select-popout__item--current');
                option.setAttribute('aria-selected', false);
            })

            element.classList.add('select-popout__item--current');
            element.setAttribute('aria-selected', true);
            let text = element.querySelector('button')?.innerHTML.trim();
            element.closest('.select-wrapper').querySelector('.select-popout__value').innerHTML = text;
            element.closest('.select-wrapper').querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
            element.closest('.select-wrapper').querySelector('.select-popout__toggle').classList.remove('active');
            element.closest('custom-select').querySelector('.select-popout__toggle').setAttribute('aria-expanded', false);
            document.querySelectorAll('.option-title__wrapper').forEach(element => {
                element.querySelector('.zin-radio__input:checked').click();
            }) 
        })
    })

    /* Sort Function */

    function sortTableByColumn(element, text) {
        const rows = Array.from(element.querySelectorAll(".product-wrapper__item"));

        // Sort each row
        const sortedRows = rows.sort((a, b) => {
            const aPrice = a.querySelector('.variant_price').dataset.price.trim();
            const bPrice = b.querySelector('.variant_price').dataset.price.trim();
            let aIndex = a.dataset.itemIndex.trim();
            let bIndex = b.dataset.itemIndex.trim();
            if(text.includes('High to Low')){
                return bPrice - aPrice 
            }else if(text.includes('Low to High')){
                return aPrice - bPrice 
            }else if(text.includes('Mattress Type')){
                return aIndex - bIndex 
            }
            
        });

        // Remove all existing TRs from the table
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }

        // Re-add the newly sorted rows
        element.append(...sortedRows);
    }

    document.querySelectorAll(".sort-wrapper .select-popout__item").forEach(item => {
        item.addEventListener("click", () => {
            let text = item.querySelector('span').textContent;
            const wrapperElement = document.querySelector('.variants_wrapper');
            sortTableByColumn(wrapperElement, text);
        });
    });

    document.querySelectorAll('.selected-option__wrapper .select-wrapper').forEach((selectedOption, index) => {
        selectedOption.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(element => {
            element.addEventListener('click', function(){
                selectedOption.querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(popout =>{
                    popout.classList.remove('select-popout__item--current');
                })

                element.classList.add('select-popout__item--current');
                let text = element.querySelector('button').innerHTML.trim();
                element.closest('.select-wrapper').querySelector('.select-popout__value').innerHTML = text;
                element.closest('.select-wrapper').querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
                element.closest('.select-wrapper').querySelector('.select-popout__toggle').classList.remove('active');

                let index = element.closest('.select-wrapper').dataset.index;
                if(index==1){
                    document.querySelector(`.select-wrapper[data-index="2"]`).querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(item => {
                        item.classList.remove('hidden');
                        if(item.querySelector('span').innerHTML == text){
                            item.classList.add('hidden');
                        }
                    })
                }else{
                    document.querySelector(`.select-wrapper[data-index="1"]`).querySelectorAll('.select-popout__list__scroll .select-popout__item').forEach(item => {
                        item.classList.remove('hidden');
                        if(item.querySelector('span').innerHTML == text){
                            item.classList.add('hidden');
                        }
                    })
                }

                let optionTitle = element.querySelector('button').innerHTML.trim();
                let sizeTitle = document.querySelector('.mobile-popup__toggle .select-popout__value').innerHTML.trim();
                let materialTitle ='';
                document.querySelector(`.mobile-only .products-wraper__item[data-number="${index}"] .material-option__title`).innerHTML = optionTitle;
                if(optionTitle.includes('Hybrid')){
                    optionTitle = optionTitle.replace(' Hybrid', '');
                    materialTitle = 'Hybrid Mattress'
                }else{
                    materialTitle = 'Memory Foam'
                }

                let variantTitle = optionTitle+' / '+materialTitle+' / '+sizeTitle;

                document.querySelector(`.mobile-only .products-wraper__item[data-number="${index}"] .price-with-button`).querySelectorAll('.product-price').forEach(price => {
                    price.classList.add('hidden');
                })

                document.querySelector(`.mobile-only .products-wraper__item[data-number="${index}"] .product-image`).querySelectorAll('.image').forEach(variantImage => {
                    variantImage.classList.add('hidden');
                })

                document.querySelector(`.mobile-only .products-wraper__item[data-number="${index}"] .price-with-button [data-variant-title="${variantTitle}"]`).classList.remove('hidden');

                document.querySelector(`.mobile-only .products-wraper__item[data-number="${index}"] .product-image [data-variant-title="${variantTitle}"]`).classList.remove('hidden');

                let ratings = document.querySelector(`.ratings_json [data-variant-title="${variantTitle}"]`).innerHTML;

                document.querySelector(`.mobile-products .products-wraper__item[data-number="${index}"] .ratings`).innerHTML = ratings;

                document.querySelector('.variant_json').querySelector(`[data-title="${variantTitle}"]`).querySelectorAll('.property-item').forEach((propertyValue, number) => {
                    let property = propertyValue.innerHTML;
                    document.querySelector('.mobile-only .product-property__item').querySelectorAll('.property-wrapper')[number].querySelector(`[data-index="${index}"] .property-item`).innerHTML = property;
                })
            })
        })
    })

    document.querySelectorAll('.compare-inputs__wrapper').forEach(compareInput => {
        compareInput.querySelector('.compare-input').addEventListener('change', function(){
            let checkedNumber = document.querySelectorAll('.compare-input:checked').length;
            if(checkedNumber == 1){
                document.querySelector('.compare_selection').classList.remove('hidden');
                document.querySelector('.compare_button').disabled = true;
                document.querySelectorAll('.compare-input:not(:checked)').forEach(item => {
                    item.disabled = false;
                })
            }else if(checkedNumber == 2){
                document.querySelector('.compare_button').disabled = false;
                document.querySelectorAll('.compare-input:not(:checked)').forEach(item => {
                    item.disabled = true;
                })
            }else{
                document.querySelector('.compare_selection').classList.add('hidden');
            }
        })
    })

    document.querySelector('.compare_button').addEventListener('click', function(){
        let text = [];
        document.querySelectorAll('.compare-input:checked').forEach(item => {
            let title = item.dataset.compareText;
            text.push(title);
        })

        text.forEach((item, index) => {
            document.querySelector(`.selected-option__wrapper [data-index="${index+1}"]`).querySelector(`.select-popout__item[data-option-title="${item}"]`)?.click();
        })

        document.querySelector('.overlap').classList.add('active');

    })

    document.querySelector('.modal_close').addEventListener('click', function(){
        document.querySelector('.overlap').classList.remove('active');
    })

    function isValidEmail(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }
    if(document.querySelector('.notify_me-button')){
        document.querySelector('.notify_me-button').addEventListener('click', async function(event){
            event.preventDefault()
            const email = document.querySelector('.email_address').value;
            let checkEmail = isValidEmail(email);
            if(email && checkEmail){
                const payload = {
                    profiles: [{
                        email: email, $consent: ["email"], $source: "Compare Mattress",
                    }]
                }
    
    
                const res= await fetch("https://wapi.zinus.com/api/klaviyo/subscribe?listId=T4nEpA", {
    
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*'
                },
                crossDomain: true,
                body: JSON.stringify(payload),
                })
    
    
                const data = await res.json()
    
                if (res.ok){
                    document.querySelector('.modal-content').classList.add('hidden');
                    document.querySelector('.success_message').classList.remove('hidden');
                    document.querySelector('.warning-error-message').classList.add('hidden');
                }
    
            }else{
                document.querySelector('.warning-error-message').classList.remove('hidden');
                document.querySelector('.success_message').classList.add('hidden');
            }
        })
    }

    document.addEventListener('click', event => {
        if (!event.target.closest('.pdp-variant-3')) {
            document.querySelectorAll('.select-popout__list--visible').forEach(item => {
                item.classList.remove('select-popout__list--visible');
            });
            document.querySelectorAll('.select-popout__toggle').forEach(item => {
                item.classList.remove('active');
            });
            document.querySelectorAll('custom-select').forEach(item => {
                item.querySelector('.select-popout__toggle').setAttribute('aria-expanded', false);
            })
            // let tooltip = document.getElementById('tooltip2');
            // tooltip.style.display = "none";
        }
        
    });

    var modal = document.querySelector('.overlap');
    window.onclick = function(event) {
        if (event.target == modal) {
            modal.classList.remove('active');
        }
    }

    if(document.querySelector(".show_modal")){
        let openButton = document.querySelector(".show_modal");
        let closeButton = document.querySelector('.modal-close');
        openButton.addEventListener('click', function(){
            document.querySelector('.overlap_modal').classList.add('active');
            document.querySelector('.success_message').classList.add('hidden');
            document.querySelector('.modal-content').classList.remove('hidden');
            document.querySelector('body').classList.add('scroll-disabled');
        })
        closeButton.addEventListener('click', function(){
            document.querySelector('.overlap_modal').classList.remove('active');
            document.querySelector('body').classList.remove('scroll-disabled');
        })
    }

    class CustomSelect extends HTMLElement {
        constructor() {
            super();
            this.isExpanded = false; // Initialize to false
            this.trigger = this.querySelector('.select-popout__toggle');
            this.options = this.querySelectorAll('.select-popout__item');
            this.filters = new Set();
            this.results_count;
            this.filters_concerns = document.getElementById('sleep-concerns').dataset.currentFilters;
            this.filters_position = document.getElementsByClassName('sleep-position')[0].dataset.selectedFilter;
            this.filters_size = document.getElementsByClassName('mattress-size')[0].dataset.selectedFilter
            this.filters_type = document.getElementById('mattress_type').dataset.currentFilters;
    
            this.selectPreviousOption = this.selectPreviousOption.bind(this); // Correct binding
            this.expandOptions = this.expandOptions.bind(this);
            this.handleTriggerClick = this.handleTriggerClick.bind(this);
            this.selectOption = this.selectOption.bind(this);
            this.getUpdatedFilterValues = this.getUpdatedFilterValues.bind(this);
            this.showAll = this.showAll.bind(this);
            this.showTooltip = this.showTooltip.bind(this);
            this.hideTooltip = this.hideTooltip.bind(this);
            this.trigger.addEventListener('click', this.handleTriggerClick);
            this.trigger.addEventListener('keydown', (e) => {
                switch(e.key) {
                    case 'ArrowUp':
                        e.preventDefault();
                        if (this.isExpanded) {
                            this.selectPreviousOption(); // Call the method
                            this.selectOption(e);
                        } else {
                            this.expandOptions(); // Implement if needed
                        }
                        break;

                    case 'ArrowDown':
                        e.preventDefault();
                        
                        if(this.isExpanded) {
                            this.selectNextOption();
                            this.selectOption(e);
                        } else {
                            this.expandOptions();
                        }
                        
                        break;
                    
                    case 'Tab':
                        this.querySelector('.select-popout__toggle').setAttribute('aria-expanded', false);
                        this.querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
                        this.hideTooltip();
                    break;
                    // Implement other cases as needed
                    case 'Escape':
                    case 'Enter':
                    case ' ':
                    e.preventDefault();
                    if(e.target.classList.contains('select-popout__toggle')){
                        let AriaExpanded = this.querySelector('.select-popout__toggle').getAttribute('aria-expanded') === 'true';
                        this.querySelector('.select-popout__toggle').setAttribute('aria-expanded', !AriaExpanded);
                        this.querySelector('.select-popout__list').classList.toggle('select-popout__list--visible');
                        this.hideTooltip();
                        this.focus();
                    }else{
                        this.querySelector('.select-popout__toggle').setAttribute('aria-expanded', false);
                        this.querySelector('.select-popout__list').classList.remove('select-popout__list--visible');
                        this.hideTooltip();
                        this.focus();
                    }
                    
                    break;
                }
            });

            this.options.forEach(option => {
                option.addEventListener('click', this.selectOption);
                option.addEventListener('mouseover', () =>{
                    if(window.screen.width > 767){
                        this.showTooltip(option);
                    }
                })
                option.addEventListener('mouseout', () => {
                    this.hideTooltip(option);
                })
                option.addEventListener('focusin', function(){
                    option.querySelector('.tooltip-text')?.classList.add('active');
                })
                option.addEventListener('focusout', function(){
                    option.querySelector('.tooltip-text')?.classList.remove('active');
                })
            })
        }

        selectOption(e){
            let element = '';
            if(e.target.classList.contains('select-popout__option')){
                element=e.target;
            }else{
                element = e.target.closest('custom-select').querySelector('.select-popout__item--current .select-popout__option');
            }
            if (element.closest('.select-popout__item').classList.contains('sleep_filters')) {
                this.filters_position = "";
                this.getUpdatedFilterValues();
                
                if(this.filters.has('side')){
                    this.filters.delete('side');
                }
                if(this.filters.has('stomach')){
                    this.filters.delete('stomach');
                }
                if(this.filters.has('back')){
                    this.filters.delete('back');
                }
                if(this.filters.has('combination')){
                    this.filters.delete('combination');
                }
                if (element.closest('.select-popout__item').dataset.value) {
                    this.filters.add(element.closest('.select-popout__item').dataset.value);
                    document.getElementsByClassName('sleep-position')[0].dataset.selectedFilter = element.closest('.select-popout__item').dataset.value;
                }   
                else {
                    document.getElementsByClassName('sleep-position')[0].dataset.selectedFilter = "";
                }
                this.results_count = 0;
                document.querySelectorAll('.product-wrapper__item').forEach(item => {
                    if ((typeof item.dataset.tags !== "undefined" && item.dataset.tags !== null) && this.filters.size != 0) {
                        item.classList.remove('hidden');
                        const filtersArray = [...this.filters];
                        const hasTag = filtersArray.every(el => item.dataset.tags.includes(el));
                        if (!hasTag){
                            this.results_count++;
                            item.classList.add('hidden');
                        }
                    } else {
                        item.classList.remove('hidden');
                    }
                    if(this.results_count == 6){
                        this.showAll();
                    }
                });
                let itemTitle = this.querySelector('.select-popout__item--current span').textContent.trim();
                this.querySelector('.select-popout__value').innerHTML = itemTitle;
                let selectedItemId = element.closest('.select-popout__item').id;
                this.querySelector('.select-popout__toggle').setAttribute('aria-activedescendant', selectedItemId);
            } else {
                this.filters_size = "";
                this.getUpdatedFilterValues();
                if(this.filters.has('Twin')){
                    this.filters.delete('Twin');
                }
                if(this.filters.has('Full')){
                    this.filters.delete('Full');
                }
                if(this.filters.has('Queen')){
                    this.filters.delete('Queen');
                }
                if(this.filters.has('King')){
                    this.filters.delete('King');
                }
                if (element.dataset.value) {
                    this.filters.add(element.dataset.value);
                    document.getElementsByClassName('mattress-size')[0].dataset.selectedFilter = element.dataset.value;
                }
                let itemTitle = element.dataset.value;
                let selectedItemId = element.closest('.select-popout__item').id;
                this.querySelector('.select-popout__toggle').setAttribute('aria-activedescendant', selectedItemId);
                this.querySelector('.select-popout__value').innerHTML = itemTitle;
                this.results_count = 0;
                document.querySelectorAll('.product-wrapper__item').forEach(item => {
                    if ((typeof item.dataset.tags !== "undefined" && item.dataset.tags !== null) && this.filters.size != 0) {
                        item.classList.remove('hidden');
                        const filtersArray = [...this.filters];
                        const hasTag = filtersArray.every(el => item.dataset.tags.includes(el));
                        if (!hasTag){
                            this.results_count++;
                            item.classList.add('hidden');
                        }
                    } else {
                        item.classList.remove('hidden');
                    }
                    if(this.results_count == 6){
                        this.showAll();
                    }
                });
                document.querySelectorAll('.price-with-button').forEach(item => {
                    item.querySelectorAll('.price-wrapper').forEach(element => {
                        if (element.dataset.variantName == itemTitle) {
                            element.classList.remove('hidden');
                            let variantPrice = element.querySelector('.variant_price').dataset.price;
                            item.closest('.variant-details').querySelector('.affirm-as-low-as').setAttribute('data-amount', variantPrice);
                        } else {
                            element.classList.add('hidden');
                        }
                    })
                })
            }
            this.querySelector('.select-popout__toggle').focus();
            if (typeof affirm !== 'undefined' && affirm.ui && affirm.ui.ready) {
                affirm.ui.ready(function () {
                    affirm.ui.refresh();
                });
            }
        }

        showAll() {
            document.getElementById('no-results').classList.remove('hidden');
            document.querySelectorAll('.product-wrapper__item').forEach(item => {
                item.classList.remove('hidden');
            });
        }
    
        showTooltip(option) {
            let options = this.querySelectorAll('.select-popout__item');
            options.forEach(function(element) { // Corrected the callback syntax
                element.querySelector('.tooltip-text')?.classList.remove('active');
                element.querySelector('.tooltip-text')?.classList.add('sr-only');
            });
            option.querySelector('.tooltip-text')?.classList.add('active');
            option.querySelector('.tooltip-text')?.classList.remove('sr-only');
        }
    
        hideTooltip() {
            let options = this.querySelectorAll('.select-popout__item');
            options.forEach(function(element) { // Corrected the callback syntax
                element.querySelector('.tooltip-text')?.classList.remove('active');
                element.querySelector('.tooltip-text')?.classList.add('sr-only');
            });
        }  
    
        getUpdatedFilterValues() {
            document.getElementById('no-results').classList.add('hidden');
            this.filters_concerns = document.getElementById('sleep-concerns').dataset.currentFilters;
            this.filters_position = document.getElementsByClassName('sleep-position')[0].dataset.selectedFilter;
            this.filters_size = document.getElementsByClassName('mattress-size')[0].dataset.selectedFilter;
            this.filters_type = document.getElementById('mattress_type').dataset.currentFilters;
    
            if (this.filters_concerns) {
                const current_filters = this.filters_concerns.split(',');
                current_filters.forEach(element => {
                    if(element != '') {
                        this.filters.add(element);
                    }
                });
            }
            if (this.filters_position) {
                this.filters.add(this.filters_position);
            }
            if (this.filters_size) {
                this.filters.add(this.filters_size);
            }
            if (this.filters_type) {
                const current_filters = this.filters_type.split(',');
                current_filters.forEach(element => {
                    if(element != '') {
                        this.filters.add(element);
                    }
                });
            }
        }
    
        handleTriggerClick(e) {
            const list = this.querySelector('.select-popout__list');
            const AriaExpanded = this.querySelector('.select-popout__toggle').getAttribute('aria-expanded') === 'true';
            this.querySelector('.select-popout__toggle').setAttribute('aria-expanded', !AriaExpanded);

            // 🔹 Close all other dropdowns first
            document.querySelectorAll('custom-select').forEach((el) => {
                if (el !== this) {
                    el.classList.remove('active');
                    el.querySelector('.select-popout__list')?.classList.remove('select-popout__list--visible');
                    el.querySelector('.select-popout__toggle')?.setAttribute('aria-expanded', false);
                    el.isExpanded = false;
                }
            });
            if (list?.classList.contains('select-popout__list--visible')) {
                this.classList.remove('active');
                list.classList.remove('select-popout__list--visible');
                this.isExpanded = false;
            } else {
                this.classList.add('active');
                list.classList.add('select-popout__list--visible');
                this.isExpanded = true;
            }
        }

        selectNextOption() {
            var currentOption = this.querySelector('.select-popout__item--current');
            if(currentOption !== undefined) {
                var currentOptionIndex = Array.prototype.slice.call(this.options).indexOf(currentOption);
                
                if(currentOptionIndex + 1 < this.options.length) {
                    var nextOption = this.options[currentOptionIndex + 1];
                    currentOption.classList.remove('select-popout__item--current');
                    document.querySelectorAll('.select-popout__list__scroll.size-toggle .select-popout__item').forEach(element =>{
                        element.setAttribute('aria-selected', false);
                    })
                    nextOption.classList.add('select-popout__item--current'); // Select the previous option
                    nextOption.setAttribute('aria-selected', true);
                    this.showTooltip(nextOption);
                }

                
            }
        }
    
        selectPreviousOption() {
            const currentOption = this.querySelector('.select-popout__item--current');
            if (currentOption) {
                const currentOptionIndex = Array.prototype.indexOf.call(this.options, currentOption);
                if (currentOptionIndex - 1 >= 0) {
                    const previousOption = this.options[currentOptionIndex - 1];
                    currentOption.classList.remove('select-popout__item--current');
                    document.querySelectorAll('.select-popout__list__scroll.size-toggle .select-popout__item').forEach(element =>{
                        element.setAttribute('aria-selected', false);
                    })
                    previousOption.setAttribute('aria-selected', true);
                    previousOption.classList.add('select-popout__item--current'); // Select the previous option
                    this.showTooltip(previousOption);
                }
            }
            
        }

        expandOptions() {
            this.trigger.setAttribute('aria-expanded', true);
            this.isExpanded = true;
        }
    }
    
    customElements.define('custom-select', CustomSelect);

    const sliders = document.querySelectorAll('.product-image__wrapper');
    if (sliders.length > 0) {
      sliders.forEach(sliderEl => {
        new Swiper(sliderEl, {
          loop: true,
          spaceBetween: 0,
          pagination: {
            el: sliderEl.querySelector('.swiper-pagination'),
            clickable: true,
          },
        });
      });
    }

    /* mobile filter functions */

    document.querySelector('.mobile-filter__container .icon-close').addEventListener('click', function(){
        document.querySelector('.mobile-filter__container .collection__filters').classList.remove('collection__filters--visible');
        document.querySelector('body').classList.remove('overflow-hidden');
    })

    document.querySelector('.mobile__fillters-toggle').addEventListener('click', function(){
        document.querySelector('.mobile-filter__container .collection__filters').classList.add('collection__filters--visible');
        document.querySelector('body').classList.add('overflow-hidden');
    })

    document.querySelectorAll('.mobile-filter__container .collection__sort__label').forEach(sortButton => {
        sortButton.addEventListener('click', function(){
            let sortWrapper = sortButton.closest('.collection__sort')?.querySelector('.collection__sort__option-wrapper');
            sortWrapper.classList.toggle('is-expanded');
            sortButton.classList.toggle('is-expanded');
            if (sortWrapper) {
                const isExpanded = sortWrapper.getAttribute('aria-expanded') === 'true';
                sortWrapper.setAttribute('aria-expanded', String(!isExpanded));
            }
        })
    })

    document.querySelectorAll('.collection__sort__options').forEach(element => {
        element.querySelectorAll('.custom-sort__input').forEach(input => {
            input.addEventListener('click', function(){
                let selectedValue = input.value;
                const target = document.querySelector(`.multi-select-option[data-value="${selectedValue}"]`);
                if (target) {
                    target.click();
                } else {
                    console.warn(`No element found with data-value="${selectedValue}"`);
                }
                input.classList.toggle('custom-collection__sort__input');
            })
        })
    })

    document.querySelectorAll('.custom-size__input').forEach(option => {
        if (option.classList.contains('sleep_filters')) {
            option.addEventListener('change', function(){
                filters_position = "";
                
                if(filters.has('side')){
                    filters.delete('side');
                }
                if(filters.has('stomach')){
                    filters.delete('stomach');
                }
                if(filters.has('back')){
                    filters.delete('back');
                }
                if(filters.has('combination')){
                    filters.delete('combination');
                }
                if (option.value) {
                    filters.add(option.value);
                    document.querySelector('.mobile-sleep-position').dataset.selectedFilter = option.value;
                }   
                else {
                    document.querySelector('.mobile-sleep-position').dataset.selectedFilter = "";
                }
                results_count = 0;
                document.querySelectorAll('.product-wrapper__item').forEach(item => {
                    if ((typeof item.dataset.tags !== "undefined" && item.dataset.tags !== null) && filters.size != 0) {
                        item.classList.remove('hidden');
                        const filtersArray = [...filters];
                        const hasTag = filtersArray.every(el => item.dataset.tags.includes(el));
                        if (!hasTag){
                            results_count++;
                            item.classList.add('hidden');
                        }
                    } else {
                        item.classList.remove('hidden');
                    }
                    if(results_count == 6){
                        showAll();
                    }
                });
                option.closest('.collection__filter-tags').querySelectorAll('.custom-size__input').forEach(input => {
                    input.classList.remove('custom-collection__sort__input');
                })
                option.classList.add('custom-collection__sort__input');
            })
        } else {
            option.addEventListener('change', function(){
                filters_size = "";
                if(filters.has('Twin')){
                    filters.delete('Twin');
                }
                if(filters.has('Full')){
                    filters.delete('Full');
                }
                if(filters.has('Queen')){
                    filters.delete('Queen');
                }
                if(filters.has('King')){
                    filters.delete('King');
                }
                if (option.value) {
                    filters.add(option.value);
                    document.querySelector('.mobile-mattress-size').dataset.selectedFilter = option.value;
                }
                let itemTitle = option.value;
                results_count = 0;
                document.querySelectorAll('.product-wrapper__item').forEach(item => {
                    if ((typeof item.dataset.tags !== "undefined" && item.dataset.tags !== null) && filters.size != 0) {
                        item.classList.remove('hidden');
                        const filtersArray = [...filters];
                        const hasTag = filtersArray.every(el => item.dataset.tags.includes(el));
                        if (!hasTag){
                            results_count++;
                            item.classList.add('hidden');
                        }
                    } else {
                        item.classList.remove('hidden');
                    }
                    if(results_count == 6){
                        showAll();
                    }
                    option.closest('.collection__filter-tags').querySelectorAll('.custom-size__input').forEach(input => {
                        input.classList.remove('custom-collection__sort__input');
                    })
                    option.classList.add('custom-collection__sort__input');
                });
                document.querySelectorAll('.price-with-button').forEach(item => {
                    item.querySelectorAll('.price-wrapper').forEach(element => {
                        if (element.dataset.variantName == itemTitle) {
                            element.classList.remove('hidden');
                        } else {
                            element.classList.add('hidden');
                        }
                    })
                })
            })
        }
    })
    

})


